import React from 'react';
import styles from './ConditionBox.module.css';

const ConditionBox = ({ condition }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.condition}>
        <span>{condition}</span>
      </div>
    </div>
  );
};

export default ConditionBox;
